import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../../../../utils/propTypes';

import PlanLayout from '../PlanLayout';
import PlanItem from '../PlanItem';

function ManufacturerPlanView({
  plan: {
    key, max_qrs: qrs, max_collections: collections, max_products: products,
  },
  t,
}) {
  return (
    <PlanLayout name={t(`plan.manufacturer.names.${key}`)}>
      <PlanItem labelKey="qrs" value={qrs} />
      <PlanItem labelKey="collections" value={collections} />
      <PlanItem labelKey="products" value={products} />
    </PlanLayout>
  );
}

ManufacturerPlanView.propTypes = {
  plan: AppPropTypes.companyPlan.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(ManufacturerPlanView);



// WEBPACK FOOTER //
// ./src/app/components/PlanModal/components/ManufacturerPlanView/index.js